/**
 * The one definition of a non-empty line of a pasted site-parameters list, shared by both sides of
 * SITE-24 (Update Site Parameters): a line of whitespace only is skipped and never counted (step 3).
 */
export function countNonEmptyLines(rawData: string): number {
  let count = 0;
  for (const line of rawData.split('\n')) {
    if (line.trim().length > 0) {
      count += 1;
    }
  }
  return count;
}
